export default function BrandSection() {
  return (
    <section className="py-28 bg-stone-50">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="text-center mb-20">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-800 mb-5" style={{ fontFamily: "'Cormorant Garamond', serif" }}>
            브랜드 소개
          </h2>
          <div className="w-20 h-1 bg-emerald-600 mx-auto"></div>
        </div>

        <div className="max-w-4xl mx-auto">
          <div className="bg-white rounded-2xl overflow-hidden shadow-xl hover:shadow-2xl transition-all duration-300">
            <div className="grid grid-cols-1 md:grid-cols-2">
              <div className="relative h-96 md:h-auto">
                <img
                  src="https://public.readdy.ai/ai/img_res/96dc8a8ba86c9db7dec685f532b18181.jpg:day%20ethical%20fashion%20studio%20photography%20clean%20simple%20background&width=600&height=700&seq=daygreen-reday-kr&orientation=portrait"
                  alt="re:day 브랜드"
                  className="w-full h-full object-cover object-top"
                />
              </div>
              
              <div className="p-12 flex flex-col justify-center">
                <h3 className="text-5xl font-bold text-gray-800 mb-6" style={{ fontFamily: "'Cormorant Garamond', serif" }}>
                  re:day
                </h3>
                <p className="text-lg text-gray-700 mb-8 leading-relaxed">
                  버려지는 자원을 다시 디자인하고
                  <br />
                  더 오래 사용할 수 있는 옷을 만듭니다
                </p>
                
                <div className="space-y-3 mb-10">
                  <div className="flex items-center gap-3">
                    <div className="w-2 h-2 bg-emerald-600 rounded-full"></div>
                    <span className="text-base text-gray-600">Recycle - 재활용</span>
                  </div>
                  <div className="flex items-center gap-3">
                    <div className="w-2 h-2 bg-emerald-600 rounded-full"></div>
                    <span className="text-base text-gray-600">Redesign - 재디자인</span>
                  </div>
                  <div className="flex items-center gap-3">
                    <div className="w-2 h-2 bg-emerald-600 rounded-full"></div>
                    <span className="text-base text-gray-600">Rebirth - 재탄생</span>
                  </div>
                </div>

                <button className="px-8 py-3.5 bg-emerald-600 text-white text-sm font-medium rounded-lg hover:bg-emerald-700 transition-colors whitespace-nowrap cursor-pointer w-fit">
                  브랜드 사이트 보기
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}